import { useMemo } from 'react'
import { useProfile } from '@front/model'
import { type UserId } from '@terros/common'

export const useStorageKey = (key: string): string => {
  const { user } = useProfile()
  return useMemo(() => toStoredKey(key, user?.userId), [key, user?.userId])
}

const toStoredKey = (storedKey: string, userId?: UserId): string => {
  if (!userId) return storedKey
  return `${userId}|${storedKey}`
}
